//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import $ from 'jquery';
import axios from 'axios';

export default {
  layout: function layout(context) {
    return global.getTheme();
  },
  data: function data() {
    return {
      email: '',
      name: '',
      current_password: '',
      new_password: '',
      new_password_confirmation: '',
      isAuth: false,
      loading: false,
      loggedUser: {},
      view: 'default'
    };
  },
  mounted: function mounted() {},

  computed: {
    lang: function lang() {
      return this.$root._route.params.lang;
    }
  },
  created: function created() {
    this.view = global.getTheme();
    if (process.client) {
      this.isAuth = this.$auth.isAuthenticated();
      this.refreshLoggedUser();
      if (!this.isAuth) {
        this.$router.push({ name: 'lang-login', params: { lang: this.lang } });
      }
    }
  },

  methods: {
    changePassword: function changePassword() {
      var _this = this;

      this.$validator.validateAll('changePasswordForm').then(function (result) {
        if (result) {
          _this.loading = true;
          var requestParams = {};
          requestParams.current_password = _this.current_password;
          requestParams.new_password = _this.new_password;
          requestParams.new_password_confirmation = _this.new_password_confirmation;

          var subscriptionUrl = global.getEndPoint() + 'api/change-password';

          axios.post(subscriptionUrl, requestParams).then(function (res) {
            if (flash) {
              if (res.data.status == 1) flash(_this.$root.trans('st_public.' + res.data.message), 'success');else flash(_this.$root.trans('st_public.' + res.data.message), 'error');
            }
            _this.loading = false;
            _this.errors.clear();
          }).catch(function (err) {
            _this.loading = false;
            if (err.message) {
              if (flash) flash(_this.$root.trans('st_public.' + err.message), 'error');
            }
            _this.errors.clear();
            var errors = err.response.data.errors;
            if (errors) {
              for (var field in errors) {
                _this.errors.add(field, errors[field].join(', '));
              }
            }
          });
        }
      });
    },
    updateProfile: function updateProfile() {
      var _this2 = this;

      this.$validator.validateAll('profileForm').then(function (result) {
        if (result) {
          _this2.loading = true;
          var requestParams = {};
          requestParams.name = _this2.name;
          requestParams.email = _this2.email;

          var subscriptionUrl = global.getEndPoint() + 'api/update-profile';

          axios.post(subscriptionUrl, requestParams).then(function (res) {
            if (flash) {
              if (res.data.status == 1) flash(_this2.$root.trans('st_public.profile_updated_successfully'), 'success');else flash(_this2.$root.trans('st_public.email_already_exists'), 'error');
            }
            _this2.loading = false;
            _this2.errors.clear();
          }).catch(function (err) {
            _this2.loading = false;
            if (err.message) {
              if (flash) flash(_this2.$root.trans('st_public.' + err.message), 'error');
            }
            _this2.errors.clear();
            var errors = err.response.data.errors;
            if (errors) {
              for (var field in errors) {
                _this2.errors.add(field, errors[field].join(', '));
              }
            }
          });
        }
      });
    },
    unsubscribe: function unsubscribe() {
      if (confirm(this.$root.trans('st_public.are you sure you\'d like to unsubscribe?'))) {
        this.callUnsubscribe();
      }
    },
    callUnsubscribe: function callUnsubscribe() {
      var _this3 = this;

      this.loading = true;
      axios.delete(global.websiteSettings.extra_info.api_endpoint + 'api/unsubscribe').then(function (res) {
        _this3.loading = false;
        if (res.data.success) {
          flash(_this3.$root.trans('st_public.' + res.data.message), 'success');
        } else {
          flash(_this3.$root.trans('st_public.' + res.data.message), 'error');
        }
        _this3.refreshLoggedUser();
      }).catch(function (err) {
        _this3.loading = false;
        if (err.message) {
          flash(_this3.$root.trans('st_public.' + err.response.data.message), 'error');
        }
      });
    },
    refreshLoggedUser: function refreshLoggedUser() {
      this.$auth.getUser(function (user) {
        this.loggedUser = user;
        this.name = user.name;
        this.email = user.email;
      }.bind(this));
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/member/profile.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/member/profile.vue
// module chunks = 38